import React from "react";
import { Helmet } from "react-helmet";
import Layout from "../../components/layout";
import CodigoEmpleadoAdminComponent from "../../components/codigoEmpleadoAdmin";
import {
  CodigoEmpleadoAdminStore,
  codigoEmpleadoAdminStore
} from "./CodigoEmpleadoAdmin.store";
import {
  CodigoEmpleadoAdminDispatcher,
  codigoEmpleadoAdminDispatcher
} from "./CodigoEmpleadoAdmin.dispatcher";
import { ReduxConnect } from "../../../toolkit/decorators/Artifact";

interface Props
  extends CodigoEmpleadoAdminStore,
    CodigoEmpleadoAdminDispatcher {}

interface State {}

@ReduxConnect(codigoEmpleadoAdminStore, codigoEmpleadoAdminDispatcher)
export default class CodigoEmpleadoAdminContainer extends React.Component<
  Props,
  State
> {
  state = {};

  render() {
    return (
      <main>
        <Helmet title="Administración de Códigos de Empleado" />
        <Layout>
          <CodigoEmpleadoAdminComponent {...this.props} />
        </Layout>
      </main>
    );
  }
}
